import { createContext } from 'react';

interface CommentContextType {
  foreignIdx: number | null;
  foreignUserIdx: number | null;
}

const CommentContext = createContext<CommentContextType | undefined>({
  foreignIdx: null,
  foreignUserIdx: null,
});

export default CommentContext;
